
import { memo } from "react";
import React, { useState, useEffect } from 'react'
import "./timer.css";

const Timer = (props) => {
    // initialize timeLeft with the seconds prop
    const [timeLeft, setTimeLeft] = useState(props.seconds);

    // console.log(props.gotoFailed);
    const [addTime, setAddTime] = useState(props.isReversed);

    const reverseTimer =(initialTimeOut)=>{
        setTimeLeft(initialTimeOut);
        setAddTime(true);
    }

    useEffect(() => {
        
        if (props.timerRef) {
            //console.log("reverse called")
            props.timerRef.current = reverseTimer;
        }
    })

    useEffect(() => {
        if(addTime){
            // do nothing here
        }else{

            if (timeLeft === 0) {
                props.gotoFailed();
    
            } else if (timeLeft === 30) {
                if (props.setUpWarningSound) {
                    // not all the componet has this props.
                    props.setUpWarningSound();
                }
    
            }
        }

        // save intervalId to clear the interval when the
        // component re-renders
        const intervalId = setInterval(() => {
            if (addTime) {
                setTimeLeft(timeLeft + 1);
                props.updateTimerValue(timeLeft);
            }
            else {
                setTimeLeft(timeLeft - 1);
                props.updateTimerValue(timeLeft);
            }

        }, 1000);

        // clear interval on re-render to avoid memory leaks
        return () => clearInterval(intervalId);
        // add timeLeft as a dependency to re-rerun the effect
        // when we update it
    }, [props, addTime, timeLeft]);

    const formatTimeLeft = (d) => {

        d = Number(d);
        //var h = Math.floor(d / 3600);
        var m = Math.floor(d % 3600 / 60);
        var s = Math.floor(d % 3600 % 60);
        var mDisplay = m > 0 ? (m >= 10 ? m : "0" + m) : "00";
        var sDisplay = s > 0 ? (s >= 10 ? s : "0" + s) : "00";
        return mDisplay + ':' + sDisplay;

    }
    return (
        <div className="timerStyle">
            {timeLeft === 0 ? "00:00" : formatTimeLeft(timeLeft)}
        </div>
    );
};

export default memo(Timer);